/**
 * 认证工具函数
 */

// 使用项目前缀，避免与其他项目冲突
const PROJECT_PREFIX = 'koi_';
const TOKEN_KEY = PROJECT_PREFIX + 'tokenId';
const USER_INFO_KEY = PROJECT_PREFIX + 'user_info';

/**
 * 设置 token
 * @param {string} token 
 */
export const setToken = (token) => {
  localStorage.setItem(TOKEN_KEY, token);
};

/**
 * 获取 token
 * @returns {string|null}
 */
export const getToken = () => {
  return localStorage.getItem(TOKEN_KEY);
};

/**
 * 移除 token
 */
export const removeToken = () => {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(USER_INFO_KEY);
};

/**
 * 设置用户信息（只存储非敏感字段）
 * @param {object} userInfo 
 */
export const setUserInfo = (userInfo) => {
  // 只存储必要的非敏感信息
  const safeUserInfo = userInfo ? {
    userId: userInfo.userId,
    name: userInfo.name,
    img: userInfo.img,
    email: userInfo.email,
    isMerchant: userInfo.isMerchant,
    isActive: userInfo.isActive,
    isWithdraw: userInfo.isWithdraw,
    isGroup: userInfo.isGroup,
    isIvt: userInfo.isIvt,
    isFroze: userInfo.isFroze,
    msgTotal: userInfo.msgTotal,
    // 注意：不要存储 pwd、tokenId 等敏感字段
  } : null;
  localStorage.setItem(USER_INFO_KEY, JSON.stringify(safeUserInfo));
};

/**
 * 获取用户信息
 * @returns {object|null}
 */
export const getUserInfo = () => {
  const info = localStorage.getItem(USER_INFO_KEY);
  return info ? JSON.parse(info) : null;
};

/**
 * 检查是否已登录
 * @returns {boolean}
 */
export const isLoggedIn = () => {
  return !!getToken();
};
